// extracted by mini-css-extract-plugin
export default {"root":"privatePage_root__19ikg","siteLayout":"privatePage_siteLayout__XNSRr","content":"privatePage_content__J2gkc","mobile":"privatePage_mobile__Qdv2j"};